module.exports = __webpack_public_path__ + "img/upward_download.3ad7d6d6.png";